'use strict';

var BBModel = Backbone.Model;
var BBModelProtoSet = BBModel.prototype.set;
var triggerEvent = function(model, active) {
    model.trigger(active ? 'on' : 'off', model);
};
var parseSetMethodArgs = require('../../modules/utils/model.utils').parseSetMethodArgs;

module.exports = BBModel.extend({
    defaults: function() {
        return {
            data: new BBModel(),
        };
    },
    initialize: function() {
        this.listenTo(this, 'change:active', triggerEvent);
    },
    set: function() {
        var args = parseSetMethodArgs(arguments);
        var attrs = args[0];
        var data = attrs.data;
        if (Odigeo._.isEmpty(this.attributes)) {
            BBModelProtoSet.call(this, this.defaults());
        }
        attrs =Odigeo._.omit(attrs, 'data');
        BBModelProtoSet.call(this, attrs);
        this.get('data').set(data);
    },
});
